export default __webpack_public_path__ + "static/media/EM1040.34I-27023_-16403_0.d35273ce.jpg";